import Input from '../../../../../Form/src/jsx/Input';
import InputGroup from '../../../../../Form/src/jsx/InputGroup';
import Switch from '../../../../../Form/src/jsx/Switch';
import Textarea from '../../../../../Form/src/jsx/Textarea';
import { FormField } from '../../types/rest';

interface FormProps {
	groupedFields: FormField[][];
	getLabel: (key: string) => string;
	isSubmitting: boolean;
	updateFieldValue: (name: string, value: string | string[] | boolean) => void;
}

export default function Form({ groupedFields, getLabel, isSubmitting, updateFieldValue }: FormProps) {
	const getFormFieldElement = (formField: FormField) => {
		const { value, ...commonProps } = {
			disabled: isSubmitting,
			errorMessages: formField.error ? [formField.error] : [],
			label: formField.label,
			name: formField.name,
			onChange: (value: string | string[] | boolean) => updateFieldValue(formField.name, value),
			placeholder: formField.placeholder || '',
			required: formField.required,
			value: formField.value,
		};

		if (formField.clone) {
			return (
				<InputGroup
					{...commonProps}
					name={formField.name}
					value={value as string[]}
					text={{
						addItem: formField.add_item_text || getLabel('input_group_add_item_default'),
						removeItem: formField.remove_item_text || getLabel('input_group_remove_item_default'),
					}}
					description={formField.description || ''}
					maxItems={formField.max_items}
					type={formField.type}
				/>
			);
		}

		switch (formField.type) {
			case 'checkbox':
				return <Switch {...commonProps} checked={!!formField.checked} value={value as string} />;
			case 'textarea':
				return <Textarea {...commonProps} value={value as string} />;
			default:
				return <Input {...commonProps} type={formField.type} value={value as string} />;
		}
	};

	return (
		<div className="booking__form">
			{groupedFields.map((row, rowIndex) => (
				<div key={rowIndex} className="booking__form-row">
					{row.map((field) => (
						<div key={field.name} className="booking__form-field">
							{getFormFieldElement(field)}
						</div>
					))}
				</div>
			))}
		</div>
	);
}
